export default {
    data() {
        return {
            valid: {
                title: this.channel?.system == "sms",
                body: false,
                button: this.channel?.system != "viber",
                link: false,
                validityPeriod: false,
                buttonUrl: false,
                fallback: false,
                image: false,
                subject: false,
            },
            success: {
                title: this.channel?.system == "sms",
                body: false,
                link: false,
                button: this.channel?.system != "viber",
                validityPeriod: false,
                buttonUrl: false,
                fallback: false,
                image: false,
                subject: false,
            },
            error: {
                title: "",
                body: "",
                link: "",
                button: "",
                validityPeriod: "",
                buttonUrl: "",
                fallback: "",
                image: "",
                subject: "",

            },
            errorMessages: {
                titleRequired: {
                    el: "Απαιτείται τίτλος",
                    en: "Title is required",
                    it: "Il titolo è richiesto"
                },
                bodyRequired: {
                    el: "Απαιτείται περιεχόμενο",
                    en: "Content is required",
                    it: "Il contenuto è richiesto"
                },
                urlInvalid: {
                    el: "Μη έγκυρη διεύθυνση URL",
                    en: "Invalid URL",
                    it: "URL non valido"
                },
                buttonRequired: {
                    el: "Απαιτείται κείμενο κουμπιού",
                    en: "Button text is required",
                    it: "Il testo del pulsante è necessario"
                },
                buttonUrlRequired: {
                    el: "Απαιτείται σύνδεσμος κουμπιού",
                    en: "Button URL is required",
                    it: "URL del pulsante è necessario"
                },
                buttonUrlInvalid: {
                    el: "Μη έγκυρη διεύθυνση URL",
                    en: "Invalid URL",
                    it: "URL non valido"
                },
                imageRequired: {
                    el: "Απαιτείται εικόνα",
                    en: "Image required",
                    it: "Immagine richiesta"
                },
                imageInvalid: {
                    el: "Μη έγκυρη εικόνα",
                    en: "Invalid image",
                    it: "Immagine non valido"
                },
                validityPeriodRequired:{
                    el: "H περίοδος εγκυρότητας δεν μπορεί να είναι μικρότερη από 60",
                    en: "The validity period may not be less than 60",
                    it: "Il periodo di validità non può essere inferiore a 60"
                },
                subjectRequired: {
                    el: "Απαιτείται θέμα",
                    en: "Subject required",
                    it: "Soggetto richiesto"
                },

            }
        };
    },

    computed: {
        formValid() {
            return (this.valid.title || this.valid.subject) && this.valid.body && this.valid.link && this.valid.validityPeriod && this.valid.button && this.valid.buttonUrl && this.valid.image;
        },
    },

    methods: {
        validateTitle() {
            
            if (!['sms', 'viber'].includes(this.channel.system)) {
                if (!this.channel?.title[this.channelLang]) {
                    this.error.title = this.errorMessages.titleRequired[
                        this.lang
                    ];
                } else {
                    this.error.title = "";
                }
            } else {
                this.error.title = "";
            }
        },
        validateButton() {
            if (this.channel?.system == "viber" && this.channel?.promotional ) {
                if (!this.channel?.button[this.channelLang]) {
                    this.error.button = this.errorMessages.buttonRequired[
                        this.lang
                    ];
                } else {
                    this.error.button = "";
                }
            } else {
                this.error.button = "";
            }
        },

        validateBody() {
            if (!this.channel?.body || (this.channel?.system !== 'mail' && !this.channel?.body[this.channelLang])) {
                this.error.body = this.errorMessages.bodyRequired[this.lang];
            } else {
                this.error.body = "";
            }
        },
        isValidURL(url) {
            try {
                return Boolean(new URL(url));
            } catch (e) {
                return false;
            }
        },
        isValidImage(img) {
            try {
                return ['image/jpg', 'image/jpeg', 'image/png'].includes(img?.type||'')
            } catch (e) {
                return false;
            }
        },
        validateLink() {
            this.error.link = "";
            if ( !["sms", "viber"].includes(this.channel?.system)) {
                if (this.channel?.link && !this.isValidURL(this.channel?.link)) {
                    this.error.link = this.errorMessages.urlInvalid[this.lang];
                } else {
                    this.error.link = "";
                }
            }
        },
        validateValidityPeriod() {
            this.error.validityPeriod = "";
            if (this.channel?.system == "viber") {
                if (this.channel?.validity_period != undefined && (Number(this.channel?.validity_period) < 60 || isNaN(Number(this.channel?.validity_period)))) {
                    this.error.validityPeriod = this.errorMessages.validityPeriodRequired[this.lang];
                } else {
                    this.error.validityPeriod = "";
                }
            }
        },
        validateButtonUrl() {
            this.error.buttonUrl = "";
            if (this.channel?.system == "viber" && this.channel?.promotional) {
                if (this.channel?.button_url && !this.isValidURL(this.channel?.button_url)) {
                    this.error.buttonUrl = this.errorMessages.buttonUrlInvalid[this.lang];
                }
            }
        },
        validateImage() {
            this.error.image = "";
            if (this.channel?.has_image || this.channel?.promotional) {
                    this.success.image = false
                    this.valid.image = false;
                    if(this.channel?.image_file && !this.isValidImage(this.channel?.image_file)){
                    this.error.image = this.errorMessages.imageInvalid[this.lang];
                }
            }
            if (!this.error.image) {
                this.success.image = true
                this.valid.image = true;
            }
        },
        validateFallback() {
            if (this.channel?.system == "viber" && this.channel?.fallback) {
                if (!this.channel?.sms[this.channelLang]) {
                    this.error.fallback = this.errorMessages.bodyRequired[
                        this.lang
                    ];
                } else {
                    this.error.fallback = "";
                }
            } else {
                this.error.fallback = "";
            }
        },
        
        validateSubject() {
            if (!this.channel?.subject) {
                this.error.subject = this.errorMessages.subjectRequired[this.lang];
            } else {
                this.error.subject = "";
            }
        },
    },

    watch: {

        ["channel.title"]: {
            immediate: true,
            handler(val) {
                    this.valid.title = ['sms', 'viber'].includes(this.channel?.system) || val && !!val?.el && !!val?.en && !!val?.it;
                    this.success.title = ['sms', 'viber'].includes(this.channel?.system) || val && !!val?.el && !!val?.en && !!val?.it;
            },
            deep: true
        },

        ["channel.button"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.button = !this.channel?.promotional || !!val?.el && !!val?.en && !!val?.it;
                    this.success.button = !this.channel?.promotional || !!val?.el && !!val?.en && !!val?.it;
                }
            },
            deep: true
        },

        ["channel.body"]: {
            immediate: true,
            handler(val) {
                    if (this.channel?.system == 'mail') {
                        this.valid.body = !!val;
                        this.success.body = !!val;
                    }else{
                        this.valid.body = !!val?.el && !!val?.en && !!val?.it;
                        this.success.body = !!val?.el && !!val?.en && !!val?.it;
                    }
            },
            deep: true
        },

        ["channel.subject"]: {
            immediate: true,
            handler(val) {
                    this.valid.subject = !!val;
                    this.success.subject = !!val;
            },
            deep: true
        },

        ["channel.link"]: {
            immediate: true,
            handler(val) {
                if (!val || this.isValidURL(val)) {
                    this.valid.link = true;
                    this.success.link = val && true;
                } else {
                    this.success.link = false;
                    this.valid.link = false;
                }
            }
        },

        ["channel.button_url"]: {
            immediate: true,
            handler(val) {
                if (!this.channel?.promotional || !val || this.isValidURL(val)) {
                    this.valid.buttonUrl = true;
                    this.success.buttonUrl = val && true;
                } else {
                    this.success.buttonUrl = false;
                    this.valid.buttonUrl = false;
                }
            }
        },

        ["channel.image_file"]: {
            immediate: true,
            handler(val) {
                if (this.channel?.promotional) {
                    if (this.channel?.image && !val) {
                        // existing image URL, no new file -> valid
                        this.valid.image = true;
                        this.success.image = true;
                        this.error.image = "";
                        return;
                    }
                    if (!val) {
                        // no image file and no existing image -> valid (image is optional)
                        this.valid.image = true;
                        this.success.image = false;
                        this.error.image = "";
                        return;
                    }
                }
                if (!this.isValidImage(val)) {
                    this.success.image = false;
                    this.valid.image = false;
                    this.error.image = this.errorMessages.imageInvalid[this.lang];
                }else{
                    this.error.image = ''  
                }
                if (this.channel?.has_image || this.channel?.promotional) {
                    this.valid.image = val && true;
                    this.success.image = val && true;
                    if (this.channel?.promotional && !val) {
                        this.valid.image = true;
                        this.error.image = '';
                    }else{
                        this.error.image = ''
                    }
                } else {
                    this.success.image = false;
                    this.valid.image = !this.channel?.promotional;
                }
            },
            deep:true
        },

        ["channel.validity_period"]: {
            immediate: true,
            handler(val) {
                if (val === undefined || Number(val) >= 60 ) {
                    this.valid.validityPeriod = true;
                    this.success.validityPeriod = val && true;
                } else {
                    this.success.validityPeriod = false;
                    this.valid.validityPeriod = false;
                }
            }
        },
        

        ["channel.sms"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.sms = !this.channel?.fallback ||!!val?.el && !!val?.en && !!val?.it;
                    this.success.sms = !this.channel?.fallback ||!!val?.el && !!val?.en && !!val?.it;
                }
            },
            deep: true
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    title: this.channel?.system == "sms",
                    button: false,
                    body: false,
                    link: false,
                    validityPeriod: false,
                    buttonUrl: false,
                    fallback: false,
                    subject: false,
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        title: "",
                        button: "",
                        body: "",
                        link: "",
                        validityPeriod: "",
                        buttonUrl: "",
                        fallback: "",
                        subject: "",
                    };

                    this.setResetValidation(false);
                }
            }
        }
    },
    
    // mounted() {
    //     if (this.channel === null) {
    //     }
    // }
};
